import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Label, Input, Button, Modal, ModalFooter, ModalHeader, ModalBody } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Moment from 'react-moment';
import 'moment-timezone';
import { getApiToken } from '../msalInstance';

function EditInputs(props) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    function closeModal() {
        setData(null);
        props.setModalItemID(null);
        props.setShowModal(false);
    }

    async function HandleSubmit(e) {
        e.preventDefault();
        const accessToken = await getApiToken();

        const submitOptions = {
            method: 'put',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
            body: JSON.stringify({
                internalValue: e.target.internal_value.value,
                externalValue: e.target.external_value.value,
                notes: e.target.notes.value,
                modifiedBy: props.username,
                sortorder: e.target.sortOrder.value,
                isInternal: e.target.is_internal.checked,
                isExternal: e.target.is_external.checked,
                name: e.target.displayName.value
            })
        };

        fetch(`/api/Inputs/${props.itemID}`, submitOptions)
            .then((response) => {
                return response;
            })
            .catch((err) => {
                setError(err.message);
            })
            .finally(() => {
                setData(null);
                props.setModalItemID(null);
                closeModal();
                props.getInputs();
            });

    }

    useEffect(() => {
        if (props.itemID && !data) {
            fetch(`/api/Inputs/${props.itemID}`)
                .then((response) => {
                    return response.json();
                })
                .then((actualData) => {
                    setData(actualData);
                    setError(null);
                })
                .catch((err) => {
                    setError(err.message);
                    setData(null);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    });

    return (
        <Modal isOpen={props.showModal}>
            {loading && <div>Loading...</div>}
            {error && (
                <div>{`There is a problem fetching the post data - ${error}`}</div>
            )}
            {data &&
                (
                    <>
                        <ModalHeader>
                            {data.name}
                        </ModalHeader>
                        <ModalBody>
                            <Container>
                                <Form onSubmit={(evt) => HandleSubmit(evt)}>
                                    <Row className="mb-2">
                                        <Col xs="4">
                                            <Label htmlFor="displayName">Display Name</Label>
                                        </Col>
                                        <Col xs="8">
                                            <Input required type="text" name="displayName" defaultValue={data.name} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col xs="4">
                                            <Label for="internalValue">Visbility</Label>
                                        </Col>
                                        <Col xs="4" className="mt-1">
                                            <Input type="checkbox" name="is_internal" defaultChecked={data.isInternal} />
                                            <label className="lblDescription" htmlFor="is_internal">Internal</label>
                                        </Col>
                                        <Col xs="4" className="mt-1">
                                            <Input type="checkbox" name="is_external" defaultChecked={data.isExternal} />
                                            <label className="lblDescription" htmlFor="is_external">External</label>
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col xs="4">
                                            <Label for="internalValue">Internal Label</Label>
                                        </Col>
                                        <Col xs="8">
                                            <Input required type="text" name="internal_value" defaultValue={data.internalValue} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col xs="4">
                                            <Label for="externalValue">External Label</Label>
                                        </Col>
                                        <Col xs="8">
                                            <Input required type="text" name="external_value" defaultValue={data.externalValue} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col xs="4">
                                            <Label for="notes">Notes</Label>
                                        </Col>
                                        <Col xs="8">
                                            <Input type="textarea" name="notes" defaultValue={data.notes} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="4">
                                            <Label for="sortorder">Sort Order</Label>
                                        </Col>
                                        <Col xs="8">
                                            <Input step="1" type="number" required name="sortOrder" defaultValue={data.sortOrder} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12">
                                            <div className="modifiedByText">Last modified by {data.modifiedBy} on <Moment local format="MM/DD/YY hh:mm a">{data.modified}</Moment></div>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <ModalFooter>
                                            <Button onClick={closeModal}>
                                                Cancel
                                            </Button>
                                            <Button variant="primary" type="Submit">
                                                Submit
                                            </Button>
                                        </ModalFooter>
                                    </Row>
                                </Form>
                            </Container>
                        </ModalBody>
                    </>
                )}

        </Modal>
    )
}

export default EditInputs;
